module.exports = __webpack_public_path__ + "4a45f95892af19f1f7b230803045fadd.svg";


//////////////////
// WEBPACK FOOTER
// ./components/home/password_reset_done/success-group.svg
// module id = 569
// module chunks = 0